import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { HomepageComponent } from '../app/homepage/homepage.component';
import { ReportsComponent } from '../app/reports/reports.component';
import { AuthGuard } from '../app/auth/auth.guard';

//import { ApplicantLoginComponent } from './registration/applicant-login/applicant-login.component';
// Import all modules directly
//import { RegistrationModule } from './registration/registration.module';

import { RegistrationComponent } from './registration/registration.component';
//import { LoginComponent } from './registration/login/login.component';
import { ApplicantLoginComponent } from './registration/applicant-login/applicant-login.component';
import { EmployeeLoginComponent } from './registration/employee-login/employee-login.component';
import { ApplicantRegisterComponent } from './registration/applicant-register/applicant-register.component';
import { ApplicantRegisterFormComponent } from './registration/applicant-register-form/applicant-register-form.component';
//start applicant //saheb
//start applicant //saheb
import { ApplicantComponent } from '../app/applicant/applicant.component';
import { StatusviewComponent } from '../app/applicant/status/statusview/statusview.component';
import { AppstatusComponent } from '../app/applicant/appstatus/appstatus.component';
import { ApplicationinstallmentpayComponent } from '../app/applicant/applicationinstallmentpay/applicationinstallmentpay.component';
import { ApplicationcancellationComponent } from '../app/applicant/applicationcancellation/applicationcancellation.component';
import { ApplicationrefundComponent } from '../app/applicant/applicationrefund/applicationrefund.component';
import { ApplicationViewComponent } from '../app/applicant/application-view/application-view.component';
import { ProfileComponent } from '../app/applicant/profile/profile.component';
import { OfflineApplicationGridComponent } from '../app/applicant/offline-application/offline-application-grid/offline-application-grid.component';
import { offlineapplicationComponent } from '../app/applicant/offline-application/offline-application.component';
import { ChangeRequestComponent } from '../app/applicant/change-request/change-request.component';
import { AllotNotallotComponent } from '../app/applicant/allot-notallot/allot-notallot.component';
import { ActivelistComponent } from '../app/applicant/apply/activelist/activelist.component';
import { ApplicationstatusComponent } from '../app/applicant/applicationstatus/applicationstatus.component';
import { ReviseBasePriceComponent } from '../app/applicant/revise-base-price/revise-base-price.component';
import { ReviseBaseGridComponent } from '../app/applicant/revise-base-price/revise-base-grid/revise-base-grid.component';
import { ApplicantDetailsUpdateComponent } from '../app/applicant/applicant-details-update/applicant-details-update.component';
import { ApplicantPaymentComponent } from '../app/applicant/applicant-payment/applicant-payment.component';
import { ChangeAddressComponent } from '../app/applicant/change-address/change-address.component';
import { BidderViewComponent } from '../app/applicant/bidder-view/bidder-view.component';
import { RefundRequestComponent } from '../app/applicant/refund-request/refund-request.component';
import { PaymentComponent } from '../app/applicant/payment/payment.component';
import { TransactionDetailsComponent } from '../app/applicant/transaction-details/transaction-details.component';
import { ApplicantQueryComponent } from '../app/applicant/applicant-query/applicant-query.component';
import { DirectAllocationComponent } from '../app/applicant/direct-allocation/direct-allocation.component';
// import { ApplicantMenuComponent } from '../app/applicant/applicant-menu/applicant-menu.component'; //important
import { InstallmentPaymentFormComponent } from '../app/applicant/installment-payment/installment-payment-form/installment-payment-form.component';
import { QueryApplicantComponent } from '../app/applicant/query-applicant/query-applicant.component';
import { ApplicationOnlineViewComponent } from '../app/applicant/application-online-view/application-online-view.component';
import { ApplicationformComponent } from './allocation/forms/applicationform/applicationform.component';

//start allocation

import { HomepageModule } from './homepage/homepage.module';
import { ApplicantModule } from './applicant/applicant.module';
import { MasterlandModule } from './master/masterland.module';
import { HrmsModule } from './hrms/hrms.module';
import { UltilitiesModule } from './ultilities/ultilities.module';
import { RtionlineModule } from './rtionline/rtionline.module';
import { HrmsComponent } from './hrms/hrms.component';
import { EmpChangeAddressComponent } from './hrms/emp-change-address/emp-change-address.component';
import { EmpApplyLeaveComponent } from './hrms/emp-apply-leave/emp-apply-leave.component';
import { EmpBankDetailsComponent } from './hrms/emp-bank-details/emp-bank-details.component';
import { EmpNominationComponent } from './hrms/emp-nomination/emp-nomination.component';
import { EmpPayslipComponent } from './hrms/emp-payslip/emp-payslip.component';
import { ChangePasswordComponent } from './ultilities/change-password/change-password.component';
import { UltilitiesComponent } from './ultilities/ultilities.component';
import { RtiOnlineComponent } from './rtionline/rtionline.component';
import { SubmitRequestFormComponent } from './rtionline/submitrequest/submitrequest-form/submitrequest-form.component';
import { SubmitRequestGridComponent } from './rtionline/submitrequest/submitrequest-grid/submitrequest-grid.component';
import { RegistrationNewComponent } from './registration/registration-new/registration-new.component';
import { FormApplicationComponent } from './registration/form-application/form-application.component';
import { VerifyRegisterComponent } from './registration/verify-register/verify-register.component';
import { Page1Component } from './registration/page1/page1.component';
import { Page2Component } from './registration/page2/page2.component';
import { Page3Component } from './registration/page3/page3.component';
import { EmpComplaintComponent } from './hrms/emp-complaint/emp-complaint.component';
import { TermsConditionComponent } from './registration/terms-condition/terms-condition.component';
import { ConfirmPawordComponent } from './registration/confirm-password/confirm-password.component';
import { ForgotPasswordOtpComponent } from './registration/forgot-password-otp/forgot-password-otp.component';
import { ForgotPasswordComponent } from './registration/forgot-password/forgot-password.component';
import { EmpLeaveEncashmentComponent } from './hrms/emp-leave-encashment/emp-leave-encashment.component';
import { PaymentFailureComponent } from './registration/payment-failure/payment-failure.component';
import { PaymentSuccessComponent } from './registration/payment-success/payment-success.component';
import { RegisPaymentSummaryComponent } from './registration/regis-payment-summary/regis-payment-summary.component';
import { AppformPaymentSummaryComponent } from './registration/appform-payment-summary/appform-payment-summary.component';
import { AgainstNotificationFormComponent } from './registration/against-notification-form/against-notification-form.component';
import { AgainstNotificationForm2Component } from './registration/against-notification-form2/against-notification-form2.component';
import { AgainstNotificationForm3Component } from './registration/against-notification-form3/against-notification-form3.component';
import { AgainstNotificationForm4Component } from './registration/against-notification-form4/against-notification-form4.component';
import { AgainstNotificationForm5Component } from './registration/against-notification-form5/against-notification-form5.component';
import { AgainstNotificationForm6Component } from './registration/against-notification-form6/against-notification-form6.component';

const routes: Routes = [
  /*
  {
    path: '', redirectTo: '/applicant-login', pathMatch: 'full'
  },

  {
    path: 'applicant-login', component: ApplicantLoginComponent,   
  },
  */

  /*
  
  {
    path: 'registration',
    loadChildren: () => RegistrationModule
  },

*/

  {
    path: '',
    redirectTo: '/applicant-login',
    pathMatch: 'full'
  },

  {
    path: 'applicant-login', component: ApplicantLoginComponent,
  },
  {
    path: 'payment-failure', component: PaymentFailureComponent,
  },
  {
    path: 'payment-success', component: PaymentSuccessComponent,
  },
  
  {
    path: 'employee-login', component: EmployeeLoginComponent,

  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
    },
    {
    path: 'forgot-password-otp',
    component: ForgotPasswordOtpComponent
    },
    {
    path: 'confirm-password',
    component: ConfirmPawordComponent
    },
  {
    path: 'applicant-register', component: RegistrationComponent,
    children: [{ path: '', component: ApplicantRegisterComponent },
    // { path: 'applicant-register-form/:NO_Id/:PD_Id/:appmode', component: ApplicantRegisterFormComponent }
    ]
   
    },
    {
    path: 'register', component: RegistrationComponent,
    children: [{ path: '', component: RegistrationNewComponent },
    // { path: 'applicant-register-form/:NO_Id/:PD_Id/:appmode', component: ApplicantRegisterFormComponent }
    ]
   
    },
    {
    path: 'page1', component: RegistrationComponent,
    children: [{ path: '', component: Page1Component },
    // { path: 'applicant-register-form/:NO_Id/:PD_Id/:appmode', component: ApplicantRegisterFormComponent }
    ]
   
    },
 {
    path: 'payment-summary', component: RegistrationComponent,
    children: [{ path: '', component: RegisPaymentSummaryComponent },
    // { path: 'applicant-register-form/:NO_Id/:PD_Id/:appmode', component: ApplicantRegisterFormComponent }
    ]
   
    },

    

    {
    path: 'appform-payment-summary', component: RegistrationComponent,
    children: [{ path: '', component: AppformPaymentSummaryComponent },
    // { path: 'applicant-register-form/:NO_Id/:PD_Id/:appmode', component: ApplicantRegisterFormComponent }
    ]
   
    },
    {
    path: 'page2', component: RegistrationComponent,
    children: [{ path: '', component: Page2Component },
    // { path: 'applicant-register-form/:NO_Id/:PD_Id/:appmode', component: ApplicantRegisterFormComponent }
    ]
   
    },
    {
    path: 'page3', component: RegistrationComponent,
    children: [{ path: '', component: Page3Component },
    // { path: 'applicant-register-form/:NO_Id/:PD_Id/:appmode', component: ApplicantRegisterFormComponent }
    ]
   
    },
    {
      path: 'terms-condition', component: RegistrationComponent,
      children: [{ path: '', component: TermsConditionComponent },
      // { path: 'applicant-register-form/:NO_Id/:PD_Id/:appmode', component: ApplicantRegisterFormComponent }
      ]
     
      },
    {
    path: 'verify', component: RegistrationComponent,
    children: [{ path: '', component: VerifyRegisterComponent },
    // { path: 'applicant-register-form/:NO_Id/:PD_Id/:appmode', component: ApplicantRegisterFormComponent }
    ]
   
    },
    {
    path: 'form-applicant', component: RegistrationComponent,
    children: [{ path: '', component: FormApplicationComponent },
    // { path: 'applicant-register-form/:NO_Id/:PD_Id/:appmode', component: ApplicantRegisterFormComponent }
    ]
   
    },
 {
    path: 'against-notification-form', component: RegistrationComponent,
    children: [{ path: '', component: AgainstNotificationFormComponent },
    // { path: 'applicant-register-form/:NO_Id/:PD_Id/:appmode', component: ApplicantRegisterFormComponent }
    ]
   
    },
    {
    path: 'against-notification-form2', component: RegistrationComponent,
    children: [{ path: '', component: AgainstNotificationForm2Component },
    // { path: 'applicant-register-form/:NO_Id/:PD_Id/:appmode', component: ApplicantRegisterFormComponent }
    ]
   
    },
    {
    path: 'against-notification-form3', component: RegistrationComponent,
    children: [{ path: '', component: AgainstNotificationForm3Component },
    // { path: 'applicant-register-form/:NO_Id/:PD_Id/:appmode', component: ApplicantRegisterFormComponent }
    ]
   
    },
    {
    path: 'against-notification-form4', component: RegistrationComponent,
    children: [{ path: '', component: AgainstNotificationForm4Component },
    // { path: 'applicant-register-form/:NO_Id/:PD_Id/:appmode', component: ApplicantRegisterFormComponent }
    ]
   
    },
    {
    path: 'against-notification-form5', component: RegistrationComponent,
    children: [{ path: '', component: AgainstNotificationForm5Component },
    // { path: 'applicant-register-form/:NO_Id/:PD_Id/:appmode', component: ApplicantRegisterFormComponent }
    ]
   
    },
      {
    path: 'against-notification-form6', component: RegistrationComponent,
    children: [{ path: '', component: AgainstNotificationForm6Component },
    // { path: 'applicant-register-form/:NO_Id/:PD_Id/:appmode', component: ApplicantRegisterFormComponent }
    ]
   
    },
  {
    path: 'submitrequest-form', component: RtiOnlineComponent,
    children: [{ path: '', component: SubmitRequestFormComponent },
    ]
    },
   
  {
    path: 'home', component: HomepageComponent, canActivate: [AuthGuard],
    children: [

      {
        path: 'change-address', component: ApplicantComponent,
        children: [{ path: '', component: ChangeAddressComponent }]
      },


      {
        path: 'appstatus', component: ApplicantComponent,
        children: [{ path: '', component: StatusviewComponent },
        { path: 'status', component: AppstatusComponent },
        { path: 'instapay/:APP_Id/:APP_No/:APP_Status', component: ApplicationinstallmentpayComponent },
        { path: 'cancellation/:APP_Id/:APP_Status', component: ApplicationcancellationComponent },
        { path: 'requestrefund/:App_Id/:APP_Status', component: ApplicationrefundComponent },
        { path: 'application-form/:NO_Id/:PD_Id/:appmode', component: ApplicationformComponent },
        { path: 'applicantview/:APP_Id/:NO_Id/:mode', component: ApplicationViewComponent },
        { path: 'application-online-view/:APP_Id/:NO_Id/:mode', component: ApplicationOnlineViewComponent }
        ]
      },
      
      {
        path: 'final-payment', component: ApplicantComponent,
        children: [{ path: '', component: InstallmentPaymentFormComponent }]
      },

      {
        path: 'transactiondetails', component: ApplicantComponent,
        children: [{ path: '', component: TransactionDetailsComponent }]
      },

      {
        path: 'query-applicant', component: ApplicantComponent,
        children: [{ path: '', component: QueryApplicantComponent }]
      },
      {
        path: 'emp-change-address', component: HrmsComponent,
        children: [
            { path: '', component: EmpChangeAddressComponent },
            { path: ':id/:mode/:empId', component: EmpChangeAddressComponent },
        ]
    },
    {
      path: 'emp-leave-encashment', component: HrmsComponent,
      children: [
      { path: '', component: EmpLeaveEncashmentComponent },
      ]
      },
      // add here if any other components required
      {
        path: 'emp-apply-leave', component: HrmsComponent,
        children: [
            { path: '', component: EmpApplyLeaveComponent },
        ]
      },
      {
        path: 'emp-nomination', component: HrmsComponent,
        children: [
            { path: '', component: EmpNominationComponent },
        ]
      },
      {
        path: 'emp-complaint', component: HrmsComponent,
        children: [
        { path: '', component: EmpComplaintComponent },
        { path: ':id/:mode/:EmpID', component: EmpComplaintComponent },
        ]
        },
      {
        path: 'emp-bank-details', component: HrmsComponent,
        children: [
            { path: '', component: EmpBankDetailsComponent },
            { path: ':id/:mode/:empId', component: EmpBankDetailsComponent },
        ]
      },
      {
        path: 'emp-payslip', component: HrmsComponent,
        children: [
            { path: '', component: EmpPayslipComponent },
        ]
      },
      
      {
        path: 'password', component: UltilitiesComponent,
        children: [{ path: '', component: ChangePasswordComponent }]
    },
    {
      path: 'password/:userId', component: UltilitiesComponent,
      children: [{ path: '', component: ChangePasswordComponent }]
  },
    ]

  }, //ALDA


];


@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts